// extracted by mini-css-extract-plugin
export default {"card":"TemplateCard-module__card__pVXNJ","active":"TemplateCard-module__active__ybWIe","content":"TemplateCard-module__content__zHUBf"};